export default __webpack_public_path__ + "static/attributes-fb9fe67e90d2ffe8a1d387e0debe78cd.png";